// Reconstructed from production code; original paths and local names were not available.
import { AppLoading } from "../components/AppLoading.jsx";
import { Link } from "react-router-dom";
import { MEDIA_BASE_URL } from "../services/config.js";
import React from "react";
import { Seo } from "../components/Seo.jsx";
import { api } from "../services/api.js";
import { canonicalUrl } from "../utils/seo.js";
import { hasUnknownQueryParams } from "../utils/seo.js";
import * as jsxRuntime from "react/jsx-runtime";
import { siteOrigin } from "../utils/seo.js";
import { useCart } from "../context/CartContext.jsx";
import { useLanguage } from "../context/LanguageContext.jsx";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useTheme } from "../context/ThemeContext.jsx";
const youtubeId = (l) => {
  if (!l) return null;
  const i = String(l).trim();
  if (!i) return null;
  try {
    const c = new URL(i),
      s = c.hostname.replace(/^www\./, "");
    if (s === "youtu.be")
      return c.pathname.split("/").filter(Boolean)[0] || null;
    if (s === "youtube.com" || s.endsWith(".youtube.com")) {
      const d = c.searchParams.get("v");
      if (d) return d;
      const f = c.pathname.split("/").filter(Boolean);
      if (f[0] === "embed" || f[0] === "shorts") return f[1] || null;
    }
  } catch {}
  return /^[a-zA-Z0-9_-]{11}$/.test(i) ? i : null;
};
function effectivePrice(l) {
  const i = Number(l?.price),
    c = Number(l?.sale_price);
  return !Number.isFinite(i) || i <= 0
    ? null
    : Number.isFinite(c) && c > 0 && c < i
      ? c
      : i;
}
function productImages(l) {
  const i = [
    ...(Array.isArray(l?.images) ? l.images.map((c) => c?.image_url) : []),
    l?.image_url,
    ...(Array.isArray(l?.variants) ? l.variants.map((c) => c?.image_url) : []),
  ].filter(Boolean);
  return [...new Set(i)].map((c) =>
    String(c).startsWith("http") ? c : `${MEDIA_BASE_URL}${c}`,
  );
}
function validGtin(l) {
  const i = String(l || "").replace(/\D/g, "");
  if (![8, 12, 13, 14].includes(i.length)) return null;
  let c = 0;
  for (let s = i.length - 2, d = 3; s >= 0; s -= 1) {
    c += Number(i[s]) * d;
    d = d === 3 ? 1 : 3;
  }
  return (10 - (c % 10)) % 10 !== Number(i[i.length - 1])
    ? null
    : {
        property: `gtin${i.length}`,
        value: i,
      };
}
const defaultBenefits = [
  {
    title: "Updated Price",
    text: "Calculated based on size.",
    title_ar: "سعر محدّث",
    text_ar: "يتم حسابه وفقاً للحجم.",
  },
  {
    title: "Easy Ordering",
    text: "Select quantity then add to cart.",
    title_ar: "طلب بسيط",
    text_ar: "اختر الكمية ثم أضف للسلة.",
  },
  {
    title: "Invoice Support",
    text: "Request an invoice at checkout.",
    title_ar: "دعم الفواتير",
    text_ar: "يمكنك طلب الفاتورة عند إتمام الشراء.",
  },
];
function parseBenefits(l) {
  try {
    const i = typeof l == "string" ? JSON.parse(l) : l;
    if (!Array.isArray(i) || !i.length) return defaultBenefits;
    const c = i
      .slice(0, 6)
      .filter((s) => s && (s.title || s.title_ar || s.text || s.text_ar))
      .map((s, d) => ({
        ...defaultBenefits[d % defaultBenefits.length],
        ...s,
      }))
      .filter((s) => s.title || s.title_ar || s.text || s.text_ar);
    return c.length ? c : defaultBenefits;
  } catch {
    return defaultBenefits;
  }
}
function ProductDetailPage() {
  const { slug: slug } = useParams(),
    i = useLocation(),
    c = useNavigate(),
    { addToCart: addToCart, items: items, loading: loading } = useCart(),
    { theme: theme } = useTheme(),
    { language: language, t: t, tProd: tProd, tText } = useLanguage(),
    b = theme?.site_name || "MyShop",
    x = siteOrigin(),
    O = `/products/${encodeURIComponent(String(slug || ""))}`,
    H = canonicalUrl(x, O),
    E = hasUnknownQueryParams(i.search),
    M = language === "ar" ? "تفاصيل المنتج" : "Product details",
    N =
      language === "ar"
        ? "اكتشف تفاصيل المنتج والخيارات المتاحة."
        : "Explore this product's details and available options.",
    [T, Y] = React.useState(null),
    [$, I] = React.useState(0),
    [K, J] = React.useState(null),
    [Q, W] = React.useState(true),
    [te, oe] = React.useState(true),
    [he, be] = React.useState(1),
    [fe, pe] = React.useState(""),
    [ye, R] = React.useState(1),
    [B, F] = React.useState({
      x: 50,
      y: 50,
    });
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [slug]);
  React.useEffect(() => {
    async function ae() {
      try {
        W(true);
        const Ge = (await api.get(`/products/${slug}`)).data;
        Y(Ge);
        Ge?.public_slug &&
          Ge.public_slug !== slug &&
          c(`/products/${Ge.public_slug}`, {
            replace: true,
          });
      } catch (de) {
        console.error("Error loading product", de);
      } finally {
        W(false);
      }
    }
    ae();
  }, [c, slug]);
  const re = React.useMemo(() => youtubeId(T?.youtube_url), [T?.youtube_url]),
    ge = React.useMemo(
      () => parseBenefits(theme?.product_assurance_items_json),
      [theme?.product_assurance_items_json],
    ),
    j = React.useMemo(() => {
      if (!T) return [];
      const ae = [];
      T.images && T.images.length
        ? T.images.forEach((de) => {
            ae.push({
              kind: "product",
              id: `p-${de.id}`,
              image_url: de.image_url,
            });
          })
        : T.image_url &&
          ae.push({
            kind: "product",
            id: "p-main",
            image_url: T.image_url,
          });
      T.variants &&
        T.variants.length &&
        T.variants.forEach((de) => {
          de.image_url &&
            ae.push({
              kind: "variant",
              id: `v-${de.id}`,
              variantId: de.id,
              image_url: de.image_url,
            });
          const Ge = youtubeId(de.youtube_url);
          Ge &&
            ae.push({
              kind: "video",
              id: `v-${de.id}-video`,
              variantId: de.id,
              image_url: `https://img.youtube.com/vi/${Ge}/mqdefault.jpg`,
              videoId: Ge,
            });
        });
      re &&
        ae.push({
          kind: "video",
          id: `y-${re}`,
          image_url: `https://img.youtube.com/vi/${re}/mqdefault.jpg`,
          videoId: re,
        });
      return ae;
    }, [T, re]),
    A = React.useCallback(
      (ae) => {
        oe(false);
        I(ae);
        const de = j[ae];
        de && (de.variantId ? J(de.variantId) : J(null));
      },
      [j],
    );
  if (
    (React.useEffect(() => {
      T && (J(null), I(0), oe(true), be(1), pe(""), R(1));
    }, [T]),
    React.useEffect(() => {
      R(1);
      F({
        x: 50,
        y: 50,
      });
    }, [$]),
    React.useEffect(() => {
      if (!j.length || !te) return;
      const ae = setInterval(() => {
        I((de) => (de + 1) % j.length);
      }, 5e3);
      return () => clearInterval(ae);
    }, [j.length, te]),
    Q)
  )
    return (
      <jsxRuntime.Fragment>
        <Seo
          title={M}
          description={N}
          canonicalUrl={H || void 0}
          type={"product"}
          siteName={b}
          language={language}
          noindex={E}
        />
        <AppLoading
          variant={"page"}
          layout={"product"}
          brand={theme?.site_name || "MyShop"}
          label={t("prodLoading")}
          detail={
            language === "ar"
              ? "نحضّر الصور والتفاصيل وخيارات المنتج."
              : "Preparing images, details, and product options."
          }
        />
      </jsxRuntime.Fragment>
    );
  if (!T)
    return (
      <jsxRuntime.Fragment>
        <Seo
          title={M}
          description={N}
          canonicalUrl={H || void 0}
          type={"website"}
          siteName={b}
          language={language}
          noindex={true}
        />
        <p>{tText("Product not found.")}</p>
      </jsxRuntime.Fragment>
    );
  const X = Number(T.price || 0),
    q = Number(T.sale_price || 0),
    Z = Number.isFinite(q) && q > 0 && q < X,
    ee =
      (T.variants?.length &&
        K != null &&
        T.variants.find((ae) => ae.id === K)) ||
      null,
    ie = ee && ee.price != null ? Number(ee.price) : null,
    Ce = ee && ee.sale_price != null ? Number(ee.sale_price) : null,
    _e = ie != null && !Number.isNaN(ie),
    ut = _e && Number.isFinite(Ce) && Ce > 0 && Ce < ie,
    gt = _e ? ut : Z,
    At = _e ? (ut ? Ce : ie) : Z ? q : X,
    ce = _e ? ie : X,
    Ee = j[$] || j[0] || null,
    Xe = Ee?.kind === "video",
    xe =
      Ee && !Xe
        ? Ee.image_url.startsWith("http")
          ? Ee.image_url
          : `${MEDIA_BASE_URL}${Ee.image_url}`
        : null,
    Ie = T.description || T.short_description || tText("No description provided."),
    wt = Xe ? Ee.videoId : null,
    Qt = wt ? `https://www.youtube-nocookie.com/embed/${wt}` : null,
    Dt = productImages(T),
    fa = Dt[0] || null,
    Zn =
      tProd(T.short_description || T.description || "")
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, 160) ||
      (language === "ar"
        ? `اكتشف ${tProd(T.name, T, "name")} والخيارات المتاحة.`
        : `Discover ${tProd(T.name, T, "name")} and its available options.`),
    _n = tProd(T.name, T, "name"),
    yt = `/products/${encodeURIComponent(String(T.public_slug || slug))}`,
    tt = canonicalUrl(x, yt),
    Ca = effectivePrice(T),
    Ka = !!T?.out_of_stock
      ? "https://schema.org/OutOfStock"
      : "https://schema.org/InStock",
    Fa = validGtin(T.barcode),
    Nn = Ca
      ? {
          "@type": "Offer",
          url: tt || void 0,
          priceCurrency: "OMR",
          price: Ca.toFixed(3),
          itemCondition: "https://schema.org/NewCondition",
          availability: Ka,
          seller: {
            "@type": "Organization",
            "@id": `${canonicalUrl(x, "/")}#organization`,
            name: b,
            url: canonicalUrl(x, "/"),
          },
        }
      : null,
    En = tt
      ? {
          "@context": "https://schema.org",
          "@type": tText("Product"),
          "@id": `${tt}#product`,
          name: _n,
          description: Zn,
          url: tt,
          image: Dt.length ? Dt : void 0,
          sku: T.sku || T.barcode || void 0,
          ...(Fa
            ? {
                [Fa.property]: Fa.value,
              }
            : {}),
          category: [tProd(T.category_name), tProd(T.subcategory_name)]
            .filter(Boolean)
            .join(" / "),
          offers: Nn || void 0,
        }
      : null,
    le = tt
      ? {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "@id": `${tt}#breadcrumb`,
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: t("home"),
              item: canonicalUrl(x, "/"),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: language === "ar" ? "المنتجات" : tText("Products"),
              item: canonicalUrl(x, "/products"),
            },
            {
              "@type": "ListItem",
              position: 3,
              name: _n,
              item: tt || void 0,
            },
          ],
        }
      : null,
    Me = [En, le].filter(Boolean),
    Te = () => {
      oe(false);
      R((ae) => (ae > 1 ? 1 : 2));
      ye > 1 &&
        F({
          x: 50,
          y: 50,
        });
    },
    ke = (ae) => {
      if (ye <= 1) return;
      const de = ae.currentTarget.getBoundingClientRect();
      F({
        x: ((ae.clientX - de.left) / de.width) * 100,
        y: ((ae.clientY - de.top) / de.height) * 100,
      });
    },
    Ke = (ae) => {
      if ((oe(false), J(ae.id), ae.image_url)) {
        const de = j.findIndex(
          (Ge) => Ge.kind === "variant" && Ge.variantId === ae.id,
        );
        de !== -1 && I(de);
        return;
      }
      if (ae.youtube_url) {
        const de = j.findIndex(
          (Ge) => Ge.kind === "video" && Ge.variantId === ae.id,
        );
        de !== -1 && I(de);
      }
    },
    Et = (ae) => {
      const de = Number(ae);
      be(Number.isNaN(de) || de <= 0 ? 1 : de);
    },
    Fn = async () => {
      if (!(!addToCart || he <= 0))
        try {
          pe("");
          await addToCart(T.id, ee ? ee.id : null, he);
          pe(
            language === "ar"
              ? "تمت إضافة المنتج إلى السلة."
              : "Product added to cart.",
          );
        } catch (ae) {
          console.error(tText("Unable to add to cart"), ae);
          pe(
            ae.response?.data?.message || ae?.message || tText("Unable to add to cart"),
          );
        }
    },
    Ls = async () => {
      const ae = Number(T?.min_order_devis || 0);
      if (ae)
        try {
          pe("");
          const de = ee ? ee.id : null,
            Ge = items.find(
              (ma) =>
                Number(ma.product_id) === Number(T.id) &&
                Number(ma.variant_id || 0) === Number(de || 0),
            ),
            Ot = Math.max(0, ae - Number(Ge?.quantity || 0));
          Ot > 0 && (await addToCart(T.id, de, Ot));
          c("/checkout?quote=1");
        } catch (de) {
          pe(
            de.response?.data?.message ||
              de?.message ||
              tText("Unable to start the quote request"),
          );
        }
    };
  return (
    <div className={"page product-detail-page customer-page"}>
      <Seo
        title={_n}
        description={Zn}
        image={fa}
        imageAlt={_n}
        canonicalUrl={tt || void 0}
        type={"product"}
        siteName={b}
        language={language}
        noindex={E}
        productPrice={Ca}
        productCurrency={"OMR"}
        schema={Me}
      />
      <div className={"product-detail-breadcrumb"}>
        <Link to={"/"}>{t("home")}</Link>
        <span>{"/"}</span>
        <Link to={"/products"}>{t("shop")}</Link>
        <span>{"/"}</span>
        <strong>{tProd(T.name, T, "name")}</strong>
      </div>
      <div className={"product-detail-header"}>
        <div>
          <h1 className={"product-detail-title"}>{tProd(T.name, T, "name")}</h1>
          <div className={"product-detail-meta"}>
            {T.short_description && (
              <span className={"product-detail-tagline"}>
                {tProd(T.short_description, T, "short_description")}
              </span>
            )}
          </div>
        </div>
        <div className={"product-detail-price-block"}>
          <span className={"price-label"}>
            {language === "ar" ? "السعر" : tText("Price")}
          </span>
          {gt ? (
            <div className={"price-row"}>
              <span className={"price-value price-value-sale"}>
                {At.toFixed(3)}{" "}
                <span className={"price-currency"}>{t("priceOMR")}</span>
              </span>
              <span className={"price-value-old"}>
                {ce.toFixed(3)} {t("priceOMR")}
              </span>
            </div>
          ) : (
            <span className={"price-value"}>
              {At.toFixed(3)}{" "}
              <span className={"price-currency"}>{t("priceOMR")}</span>
            </span>
          )}
        </div>
      </div>
      <div className={"product-detail-body"}>
        <div className={"product-detail-left"}>
          {Ee && (
            <div className={"product-detail-card"}>
              {Xe ? (
                Qt ? (
                  <iframe
                    src={Qt}
                    title={tText("Video for {0}", { 0: tProd(T.name, T, "name") })}
                    className={"product-detail-video"}
                    allow={
                      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    }
                    allowFullScreen={true}
                    loading={"lazy"}
                  />
                ) : null
              ) : (
                <jsxRuntime.Fragment>
                  <div
                    className={
                      "product-media-stage" + (ye > 1 ? " is-zoomed" : "")
                    }
                    role={"button"}
                    tabIndex={0}
                    aria-label={
                      language === "ar"
                        ? ye > 1
                          ? "اضغط لإرجاع الصورة إلى حجمها الطبيعي"
                          : "اضغط لتكبير الصورة"
                        : ye > 1
                          ? "Click to return the image to its normal size"
                          : "Click to zoom in on the image"
                    }
                    onClick={Te}
                    onKeyDown={(ae) => {
                      (ae.key === "Enter" || ae.key === " ") &&
                        (ae.preventDefault(), Te());
                    }}
                    onMouseMove={ke}
                    onMouseLeave={() =>
                      F({
                        x: 50,
                        y: 50,
                      })
                    }
                  >
                    <img
                      src={xe}
                      alt={tProd(T.name, T, "name")}
                      className={"product-detail-img"}
                      loading={"eager"}
                      fetchPriority={"high"}
                      decoding={"async"}
                      style={{
                        transform: `scale(${ye})`,
                        transformOrigin: `${B.x}% ${B.y}%`,
                      }}
                    />
                  </div>
                </jsxRuntime.Fragment>
              )}
              {j.length > 1 && (
                <jsxRuntime.Fragment>
                  <div className={"hero-dots hero-dots-small"}>
                    {j.map((ae, de) => (
                      <button
                        className={"hero-dot" + (de === $ ? " active" : "")}
                        aria-label={tText("View media {0}", { 0: de + 1 })}
                        onClick={() => A(de)}
                        key={ae.id}
                      />
                    ))}
                  </div>
                  <div className={"thumbs"}>
                    {j.map((ae, de) => {
                      const Ge = ae.image_url.startsWith("http")
                          ? ae.image_url
                          : `${MEDIA_BASE_URL}${ae.image_url}`,
                        Ot = de === $,
                        ma = ae.kind === "video";
                      return (
                        <button
                          type={"button"}
                          className={
                            "thumb-button" +
                            (ma ? " is-video" : "") +
                            (Ot ? " active" : "")
                          }
                          onClick={() => A(de)}
                          aria-label={ma ? tText("Play video") : tText("View image")}
                          key={ae.id}
                        >
                          <img
                            src={Ge}
                            alt={""}
                            className={"thumb-img" + (Ot ? " active" : "")}
                            loading={"lazy"}
                            decoding={"async"}
                          />
                          {ma && (
                            <span
                              className={"thumb-play"}
                              aria-hidden={"true"}
                            />
                          )}
                        </button>
                      );
                    })}
                  </div>
                </jsxRuntime.Fragment>
              )}
            </div>
          )}
        </div>
        <div className={"product-detail-right"}>
          <div className={"product-detail-info-card"}>
            <h2 className={"section-title"}>{t("description")}</h2>
            <p className={"product-detail-desc"}>{tProd(Ie)}</p>
            <div className={"product-detail-assurance"}>
              {ge.map((ae, de) => {
                const Ge =
                    language === "ar"
                      ? ae.title_ar || ae.title
                      : ae.title || ae.title_ar,
                  Ot =
                    language === "ar"
                      ? ae.text_ar || ae.text
                      : ae.text || ae.text_ar;
                return (
                  <div key={`${Ge}-${de}`}>
                    <strong>{tProd(Ge)}</strong>
                    <span>{tProd(Ot)}</span>
                  </div>
                );
              })}
            </div>
            {T.variants && T.variants.length > 0 && (
              <div className={"product-variants"}>
                <div className={"product-variants-label"}>
                  {language === "ar" ? "اختر الحجم" : "SELECT SIZE"}
                </div>
                <div className={"product-variants-chips"}>
                  {T.variants.map((ae) => (
                    <button
                      type={"button"}
                      className={
                        "variant-chip" + (K === ae.id ? " active" : "")
                      }
                      onClick={() => Ke(ae)}
                      key={ae.id}
                    >
                      {tProd(ae.name, ae, "name")}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {ee && (
              <div className={"selected-variant-panel"}>
                <span>{language === "ar" ? "المحدد" : "Selected"}</span>
                <strong>{tProd(ee.name, ee, "name")}</strong>
                {ee.description && <p>{tProd(ee.description, ee, "description")}</p>}
              </div>
            )}
            <div className={"product-detail-cart-row"}>
              <div className={"product-qty-control"}>
                <span>{t("quantity")}</span>
                <div className={"product-qty-buttons"}>
                  <button
                    type={"button"}
                    onClick={() => Et(he - 1)}
                    aria-label={
                      language === "ar" ? "تقليل الكمية" : "Decrease quantity"
                    }
                  >
                    <span aria-hidden={"true"}>{"−"}</span>
                  </button>
                  <input
                    type={"number"}
                    min={1}
                    value={he}
                    inputMode={"numeric"}
                    aria-label={t("quantity")}
                    onChange={(ae) => Et(ae.target.value)}
                  />
                  <button
                    type={"button"}
                    onClick={() => Et(he + 1)}
                    aria-label={
                      language === "ar" ? "زيادة الكمية" : "Increase quantity"
                    }
                  >
                    <span aria-hidden={"true"}>{"+"}</span>
                  </button>
                </div>
              </div>
              <button
                type={"button"}
                className={"btn btn-primary product-add-cart-btn"}
                onClick={Fn}
                disabled={loading}
              >
                {loading
                  ? language === "ar"
                    ? "جاري الإضافة..."
                    : "Adding..."
                  : language === "ar"
                    ? "أضف إلى السلة"
                    : "Add to Cart"}
              </button>
            </div>
            {T.out_of_stock && (
              <p
                className={"cart-info-msg cart-info-msg--stock"}
                role={"status"}
              >
                {language === "ar"
                  ? "هذا المنتج غير متوفر حالياً. يمكنك إضافته إلى السلة، لكن لا يمكن تأكيد الطلب قبل عودة المخزون."
                  : "This product is out of stock. You can add it to your cart, but the order cannot be confirmed until it is back in stock."}
              </p>
            )}
            {Number(theme?.show_bulk_quote_callout ?? 1) !== 0 &&
              Number(T.min_order_devis || 0) > 0 && (
                <div className={"product-quote-callout"}>
                  <div className={"product-quote-copy"}>
                    <span>
                      {language === "ar" ? "عرض سعر للكميات" : "Bulk quotation"}
                    </span>
                    <strong>
                      {language === "ar"
                        ? `متاح ابتداءً من ${T.min_order_devis} قطعة`
                        : `Available from ${T.min_order_devis} pieces`}
                    </strong>
                    <p>
                      {language === "ar"
                        ? "سنضيف الحد الأدنى إلى سلتك ثم يمكنك إرسال طلبك مباشرة."
                        : "We will add the minimum quantity to your cart, then you can send your request."}
                    </p>
                  </div>
                  <button
                    type={"button"}
                    className={"product-quote-btn"}
                    onClick={Ls}
                    disabled={loading}
                  >
                    {language === "ar" ? "طلب عرض سعر" : "Request a quote"}
                  </button>
                </div>
              )}
            {fe && (
              <p className={"cart-info-msg"} role={"status"}>
                {tText(fe)}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className={"product-mobile-purchase-bar"} aria-label={tProd(T.name, T, "name")}>
        <div className={"product-mobile-purchase-bar__price"}>
          <span>{language === "ar" ? "السعر" : tText("Price")}</span>
          <strong>
            {At.toFixed(3)} <small>{t("priceOMR")}</small>
          </strong>
        </div>
        <button
          type={"button"}
          className={"product-add-cart-btn"}
          onClick={Fn}
          disabled={loading}
        >
          {loading
            ? language === "ar"
              ? "جاري الإضافة..."
              : "Adding..."
            : language === "ar"
              ? "أضف إلى السلة"
              : "Add to Cart"}
        </button>
      </div>
    </div>
  );
}
export {
  youtubeId,
  effectivePrice,
  productImages,
  validGtin,
  defaultBenefits,
  parseBenefits,
  ProductDetailPage,
};
